import * as React from "react"

import { cn } from "@/lib/utils"

interface InputProps extends React.ComponentProps<"input"> {
  invalid?: boolean
  invalidText?: string
}

function Input({ className, type, invalid, invalidText, ...props }: InputProps) {
  return (
    <>
    <input
      type={type}
      data-slot="input"
      className={cn(
        "w-full rounded-lg border border-gray-300 px-4 py-3 focus:border-transparent focus:ring-2 focus:ring-secondary file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
        {
          "border-2 border-red-600": invalid === true,
        },
      )}
      {...props}
      />

      {invalid && invalidText ? (
        <p className="mt-2 text-sm text-red-600">{invalidText}</p>
      ) : null}
      </>
  )
}

export { Input }
